<div class="flex items-center gap-2">
  <i class="fa-solid fa-language text-slate-400"></i>
  <select 
    (change)="switchLanguage($event)"
    aria-label="เลือกภาษา"
    class="bg-slate-700 text-white text-sm font-semibold rounded-md border-transparent focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors py-1 pl-2 pr-8 border-0 cursor-pointer">
    @for(lang of languages; track lang.code) {
      <option [value]="lang.code" [selected]="lang.code === currentLang()">{{ lang.nameKey | translate }}</option>
    }
  </select>
</div>